'use strict';

define(function (require, exports, module) {

    // Check for subfooter and wire up dropdown logic.
    if (document.querySelector('.site-footer__subfooter')) {
        $('.site-footer__feature-toggle').click(function () {
            var $dropdown = $(this).next('.site-footer__feature-dropdown');

            if ($dropdown.css('display') === 'none') {
                $('.site-footer__feature-dropdown').hide();
            }

            $dropdown.toggle();
        });

        $(document).on('touchstart click', function (e) {
            var target = e.target;
            if (!$(target).is('.site-footer__feature-toggle') && !$(target).parents().is('.site-footer__feature-dropdown')) {
                $('.site-footer__feature-dropdown').hide();
            }
        });
    }
});
